import { combineReducers } from "redux";
import { adminAppReducer } from "./app";
import { adminUserReducer } from "./user";
import { adminUsersManagementReducer } from "./usersManagement";


const adminReducers = combineReducers({
  app: adminAppReducer,
  user: adminUserReducer,
  usersManagement: adminUsersManagementReducer,
});

export * from "./app";
export * from "./user";
export * from "./usersManagement";


export { adminReducers };
